import React from 'react';
import RModal from '../../../components/Rsuite/Modal';
import api from '../../../services/api';
import { toastSuccess, toastError } from '../../../toasts';
import { Text } from '../../../components/Text/Text';
import { Footer } from './Footer/Footer';

export function DeleteModalMounting({ open, onClose, setMontagens, montagem }) {
  const deleteMounting = async () => {
    try {
      await api.delete(`montagem-prato/deletar/${montagem.Id}`);

      toastSuccess('Montagem apagada');
      setMontagens((state) => state.filter((x) => x.Id !== montagem.Id));
      onClose();
    } catch (error) {
      console.log(error.message);
      toastError('Não foi possivel apagar montagem');
    }
  };

  return (
    <RModal
      open={open}
      onClose={onClose}
      title={'Apagar montagem'}
      sizeBody
      footer={<Footer deleteMounting={deleteMounting} onClose={onClose} />}
    >
      <Text fontSize={20}>Deseja apagar montagem?</Text>
    </RModal>
  );
}
